import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  block?: boolean;
  type?: "primary" | "secondary";
  small?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    block: { type: Boolean, default: false },
    type: { default: "primary" },
    small: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([{ block: _ctx.block, small: _ctx.small }, _ctx.type, 'app-button'])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})